import {EnergySupply} from "../services/GreenLoanService";

export function energySupplyToNorwegian(supply: EnergySupply): string {
    switch (supply) {
        case "Electricity":
            return "Elektrisitet";
        case "RemoteHeating":
            return "Fjernvarme";
    }
}